import * as _ from "lodash";
import * as angular from "angular";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { WorkflowDataProvider } from "../../data-provider/workflow.dp";

let CanvassStatusWorkflow = {
    selector: "vcCanvassStatusWorkflow",
    templateUrl:
        "/angular/components/canvass-status/canvass-status-workflow.component.html",
    bindings: {
        selectedStatus: "=?",
    },
    controller: class CanvassStatusWorkflowController {
        // * bindings for typescript compiler *
        public selectedStatus: CanvassStatus;
        // ************************************

        private dataProvider: WorkflowDataProvider;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        public workflowTypes: any[] = [
            {
                id: "appointment",
                icon: "event",
                name: "Appointment",
                description:
                    "Allow for appointments to be created when this status is selected",
            },
        ];
        public status: CanvassStatus;
        public workflow: any;
        public saving: boolean;

        constructor(
            DialogUtils: DialogUtils,
            WorkflowDataProvider: WorkflowDataProvider,
            ToastUtils: ToastUtils
        ) {
            this.dataProvider = WorkflowDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
        }

        $onInit() {
            this.status = angular.copy(this.selectedStatus);
            if (this.status && this.status.workflow) {
                this.workflow = angular.copy(this.status.workflow);
                this.workflowTypes.forEach((type: any) => {
                    type.selected = !!this.workflow[type.id]
                        ? this.workflow[type.id]
                        : false;
                });
            } else {
                this.workflow = {};
            }
        }

        selectType(type: any): void {
            if (this.workflow[type.id]) {
                this.workflow[type.id] = !this.workflow[type.id];
                type.selected = !type.selected;
            } else {
                this.workflow[type.id] = true;
                type.selected = true;
            }
        }

        saveWorkflow(status: CanvassStatus): void {
            this.saving = true;
            let data = this.workflow;
            data.id = status.id;
            this.dataProvider.update(data).then(
                (workflow: any) => {
                    this.status.workflow = workflow;

                    this.dialog.hide(this.status);
                },
                (error: any) => {
                    this.saving = false;
                    console.log(error);
                }
            );
        }

        ok(): void {
            this.saveWorkflow(this.status);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("canvassStatus")
    .component(CanvassStatusWorkflow.selector, CanvassStatusWorkflow);
